// Two grouped sections of value-prop bullets, each rendered as green checkmarks.
export const FEATURE_GROUPS = [
  {
    id: 'right-away',
    label: 'WHAT YOU GET RIGHT AWAY',
    items: [
      'Annual labs for 50+ blood biomarkers',
      'Personalized risk across 21 major cancers',
      'A clear action plan to lower your risk',
      'Personalized screening guidance',
    ],
  },
  {
    id: 'over-time',
    label: 'MONITOR HOW RISK CHANGES OVER TIME',
    items: [
      'Keep your wearable data synced',
      'Track changes to biomarkers with annual labs',
      'Get notified about new research that impacts your profile',
    ],
  },
] as const;

// Multi-disease experiment variant — same shape, alt copy for marketing cohort.
export const MULTI_DISEASE_FEATURE_GROUPS = [
  {
    id: 'right-away',
    label: 'WHAT YOU GET RIGHT AWAY',
    items: [
      'Annual labs for 50+ blood biomarkers',
      'Personalized risk across heart disease, dementia, diabetes, and cancer',
      'A clear action plan to lower your risk',
      'Personalized screening guidance',
    ],
  },
  {
    id: 'over-time',
    label: 'MONITOR HOW RISK CHANGES OVER TIME',
    items: [
      'Keep your wearable data synced',
      'Track changes to biomarkers with annual labs',
      'Get notified about new research that impacts your profile',
    ],
  },
] as const;

export type FeatureGroup = {
  id: string;
  label: string;
  items: readonly string[];
};

export const PRICING_SUBHEADER = 'A small price to pay for peace of mind';

// Testimonial data for social proof section
export const TESTIMONIALS = [
  {
    id: 'sarah',
    quote:
      '"Catch showed me I was at risk but it also gave me a clear plan. Seeing that 39% drop in my risk was the first time I felt like I was actually in control of my health."',
    name: 'Sarah M.',
    title: 'Member since 2023',
    avatarUrl: '/images/testimonials/sarah-cropped.png'
  },
  {
    id: 'dr-kahn',
    quote:
      '"I recommend Catch to patients who want to be proactive. The reports are thorough, and they actually cite their sources."',
    name: 'Dr. Joel Kahn',
    title: 'Physician',
    avatarUrl: '/images/testimonials/dr-kahn.jpg'
  },
] as const;

// Privacy badges for "Your data stays yours" section
export const PRIVACY_BADGES = [
  {
    id: 'hipaa',
    icon: 'caduceus',
    label: 'HIPAA aligned',
  },
  {
    id: 'encryption',
    icon: 'lock',
    label: 'AES-256 Encryption',
  },
  {
    id: 'never-sold',
    icon: 'no-sale',
    label: 'Never Sold',
  },
] as const;

// Trial benefits shown below payment form
export const TRIAL_BENEFITS = [
  {
    id: 'no-charge',
    text: 'No charge for 7 days',
  },
  {
    id: 'cancel',
    text: 'Cancel anytime',
  },
  {
    id: 'guarantee',
    text: '14-day money-back guarantee',
  },
] as const;

// Trust badges shown at bottom of payment card
export const TRUST_BADGES = [
  {
    id: 'ssl',
    icon: 'ssl',
    label: 'SSL SECURE',
  },
  {
    id: 'hipaa',
    icon: 'caduceus',
    label: 'HIPAA ALIGNED',
  },
] as const;

// Member count for social proof
export const MEMBER_COUNT = '17,000+';
export const MEMBER_COUNT_BASE = 17942;
